import React from 'react';

import { TESTING } from '../captivision.config';

// The pieces the tester instructions are built from, shared by every
// locales/testing.<language>.jsx.

// a link written out in full, so testers can also type it on another device
export const Url = ({ href }) => (
    <a className="cv-url" href={href} rel="noopener noreferrer">{href}</a>
)

// The survey is linked once there is one to link to. `children` is the words
// that become the link, in the page's language.
export const Survey = ({ children }) => (
    TESTING.surveyUrl
        ? <a href={TESTING.surveyUrl} rel="noopener noreferrer">{children}</a>
        : <>{children}</>
)

export const Task = ({ title, time, children }) => (
    <li>
        <div>
            <h3> {title} {time ? <span className="cv-task-time"> {time} </span> : null} </h3>
            {children}
        </div>
    </li>
)

// what to watch for during a task; `label` is "Look for" in the page's language
export const CVLookFor = ({ label, children }) => (
    <div className="cv-look">
        <b>{label}</b>
        {children}
    </div>
)
